import { connect } from 'react-redux';
import { PermissionRoute as PermRoute } from './component';
import { AppState } from 'pages/app/state';

function mapStateToProps({ login }: AppState) {
  return {
    userPermissions: login.permissions
  };
}

export const PermissionRoute = connect(mapStateToProps)(PermRoute);


// WEBPACK FOOTER //
// ./src/components/permission-route/index.ts